import { states } from './states'

export enum DocusignFieldTabLabel {
  fullName = 'fullName',
  firstName = 'firstName',
  lastName = 'lastName',
  mi = 'mi',
  email = 'email',
  driverNumber = 'driverNumber',
  address = 'address',
  city = 'city',
  state = 'state',
  county = 'county',
  zipcode = 'zipcode',
  cityStateZipcode = 'cityStateZipcode',
  prevAddress1 = 'prevAddress1',
  prevCity1 = 'prevCity1',
  prevState1 = 'prevState1',
  prevZipcode1 = 'prevZipcode1',
  prevAddress2 = 'prevAddress2',
  prevCity2 = 'prevCity2',
  prevState2 = 'prevState2',
  prevZipcode2 = 'prevZipcode2',
  phoneNumber = 'phoneNumber',
  phoneNumberHome = 'phoneNumberHome',
  driverLicenseNumber = 'driverLicenseNumber',
  driverLicenseState = 'driverLicenseState',
  ssn = 'ssn',
  ssnLast4 = 'ssnLast4',
  tin = 'tin',
  fein = 'fein',
  dob = 'dob',
  beneficiary = 'beneficiary',
  beneficiaryRelationship = 'beneficiaryRelationship',
  beneficiaryFirstName = 'beneficiaryFirstName',
  beneficiaryLastName = 'beneficiaryLastName',
  beneficiaryMI = 'beneficiaryMI',
  beneficiaryAddress = 'beneficiaryAddress',
  beneficiaryDeathToEstateCheckbox = 'beneficiaryDeathToEstateCheckbox',
  insuranceCarrier = 'insuranceCarrier',
  otherInsurancePlan = 'otherInsurancePlan',
  eSignatureAck = 'eSignatureAck',
  businessName = 'businessName',
  w9FullName = 'w9FullName',
  w9BusinessName = 'w9BusinessName',
  w9Address = 'w9Address',
  w9City = 'w9City',
  w9State = 'w9State',
  w9County = 'w9County',
  w9Zipcode = 'w9Zipcode',
  ein = 'ein',
  w9Ssn = 'w9Ssn',
  w9Ein = 'w9Ein',
  vehicleYear = 'vehicleYear',
  vehicleMake = 'vehicleMake',
  vehicleModel = 'vehicleModel',
  vehicleVIN = 'vehicleVIN',
  vehicleLicensePlate = 'vehicleLicensePlate',
  gvw = 'gvw',
  vehicleType = 'vehicleType',
  vehicleTypeOther = 'vehicleTypeOther',
  vehicleTypeRequired = 'vehicleTypeRequired',
  vehicleTypeOtherRequired = 'vehicleTypeOtherRequired',
  vehicleYear2 = 'vehicleYear2',
  vehicleMake2 = 'vehicleMake2',
  vehicleModel2 = 'vehicleModel2',
  vehicleVIN2 = 'vehicleVIN2',
  vehicleLicensePlate2 = 'vehicleLicensePlate2',
  gvw2 = 'gvw2',
  vehicleType2 = 'vehicleType2',
  vehicleTypeOther2 = 'vehicleTypeOther2',
  vehicleYear3 = 'vehicleYear3',
  vehicleMake3 = 'vehicleMake3',
  vehicleModel3 = 'vehicleModel3',
  vehicleVIN3 = 'vehicleVIN3',
  vehicleLicensePlate3 = 'vehicleLicensePlate3',
  gvw3 = 'gvw3',
  vehicleType3 = 'vehicleType3',
  vehicleTypeOther3 = 'vehicleTypeOther3',
  taxClassificationType = 'taxClassificationType',
  llcType = 'llcType',
  exemptPayeeCode = 'exemptPayeeCode',
  exemptionFatcaCode = 'exemptionFatcaCode',
  mmsOregonAddress = 'mmsOregonAddress',
  otherForeignPartners = 'otherForeignPartners',
  otherTaxClassification = 'otherTaxClassification',
  inselAgreementCheckbox = 'inselAgreementCheckbox',
  taxId = 'taxId',
  companyTitle = 'companyTitle',
  smartDeliveryCheckboxLease = 'smartDeliveryCheckboxLease',
  smartDeliveryCheckboxAdAck = 'smartDeliveryCheckboxAdAck',
  smartDeliveryCheckboxShirt = 'smartDeliveryCheckboxShirt',
  smartDeliveryCheckboxIdBadge = 'smartDeliveryCheckboxIdBadge',
  smartDeliveryCheckboxDecal = 'smartDeliveryCheckboxDecal',
  addressSinceDate = 'addressSinceDate',
  prevAddressSinceDate1 = 'prevAddressSinceDate1',
  prevAddressSinceDate2 = 'prevAddressSinceDate2',
  bankName = 'bankName',
  bankRoutingNumber = 'bankRoutingNumber',
  bankAccountNumber = 'bankAccountNumber',
  bankAccountType = 'bankAccountType',
}

export enum DocusignHiddenFieldTabLabel {
  businessTypeTextHidden = 'businessTypeTextHidden',
}

export const DocusignFieldNames = {
  [DocusignFieldTabLabel.phoneNumber]: 'Phone number',
  [DocusignFieldTabLabel.phoneNumberHome]: 'Home Phone number',
  [DocusignFieldTabLabel.email]: 'Email address',
  [DocusignFieldTabLabel.fullName]: 'Full name',
  [DocusignFieldTabLabel.firstName]: 'First name',
  [DocusignFieldTabLabel.lastName]: 'Last name',
  [DocusignFieldTabLabel.mi]: 'Middle initial',
  [DocusignFieldTabLabel.driverNumber]: 'Driver Number',
  [DocusignFieldTabLabel.address]: 'Address',
  [DocusignFieldTabLabel.city]: 'City',
  [DocusignFieldTabLabel.state]: 'State',
  [DocusignFieldTabLabel.zipcode]: 'ZIP code',
  [DocusignFieldTabLabel.county]: 'County',
  [DocusignFieldTabLabel.cityStateZipcode]: 'City, state, and ZIP code',
  [DocusignFieldTabLabel.prevAddress1]: 'Address',
  [DocusignFieldTabLabel.prevCity1]: 'City',
  [DocusignFieldTabLabel.prevState1]: 'State',
  [DocusignFieldTabLabel.prevZipcode1]: 'ZIP code',
  [DocusignFieldTabLabel.prevAddress2]: 'Address',
  [DocusignFieldTabLabel.prevCity2]: 'City',
  [DocusignFieldTabLabel.prevState2]: 'State',
  [DocusignFieldTabLabel.prevZipcode2]: 'ZIP code',
  [DocusignFieldTabLabel.ssn]: 'Social security number',
  [DocusignFieldTabLabel.ssnLast4]: 'Last 4 digits of Social security number',
  [DocusignFieldTabLabel.tin]: 'Taxpayer ID number',
  [DocusignFieldTabLabel.fein]: 'Federal employer ID number',
  [DocusignFieldTabLabel.dob]: 'Your Date of Birth',
  [DocusignFieldTabLabel.beneficiary]: 'Beneficiary',
  [DocusignFieldTabLabel.beneficiaryRelationship]: 'Relationship to Beneficiary',
  [DocusignFieldTabLabel.beneficiaryFirstName]: 'Beneficiary First Name',
  [DocusignFieldTabLabel.beneficiaryLastName]: 'Beneficiary Last Name',
  [DocusignFieldTabLabel.beneficiaryMI]: 'Beneficiary Middle Initial',
  [DocusignFieldTabLabel.beneficiaryAddress]: 'Beneficiary Address',
  [DocusignFieldTabLabel.beneficiaryDeathToEstateCheckbox]:
    'Checkbox to have death benefit paid to my Estate',
  [DocusignFieldTabLabel.insuranceCarrier]: 'If Yes, name of insurance carrier',
  [DocusignFieldTabLabel.otherInsurancePlan]:
    'Are you covered under any other medical and/or disability insurance plan?',
  [DocusignFieldTabLabel.eSignatureAck]: 'Electronic signature acknowledgement',
  [DocusignFieldTabLabel.businessName]: 'Business entity name',
  [DocusignFieldTabLabel.ein]: 'Employer Identification Number (EIN)',
  [DocusignFieldTabLabel.vehicleYear]: 'Vehicle Year',
  [DocusignFieldTabLabel.vehicleMake]: 'Vehicle Make',
  [DocusignFieldTabLabel.vehicleModel]: 'Vehicle Model',
  [DocusignFieldTabLabel.vehicleVIN]: 'Vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate]: 'Vehicle License Plate',
  [DocusignFieldTabLabel.gvw]: 'Gross Vehicle Weight (GVW)',
  [DocusignFieldTabLabel.vehicleType]: 'Vehicle Type',
  [DocusignFieldTabLabel.vehicleTypeRequired]: 'Vehicle Type',
  [DocusignFieldTabLabel.vehicleTypeOther]: 'Other Vehicle Type',
  [DocusignFieldTabLabel.vehicleTypeOtherRequired]: 'Other Vehicle Type',
  [DocusignFieldTabLabel.vehicleYear2]: 'Vehicle Year',
  [DocusignFieldTabLabel.vehicleMake2]: 'Vehicle Make',
  [DocusignFieldTabLabel.vehicleModel2]: 'Vehicle Model',
  [DocusignFieldTabLabel.vehicleVIN2]: 'Vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate2]: 'Vehicle License Plate',
  [DocusignFieldTabLabel.gvw2]: 'Gross Vehicle Weight (GVW)',
  [DocusignFieldTabLabel.vehicleType2]: 'Vehicle Type',
  [DocusignFieldTabLabel.vehicleTypeOther2]: 'Other Vehicle Type',
  [DocusignFieldTabLabel.vehicleYear3]: 'Vehicle Year',
  [DocusignFieldTabLabel.vehicleMake3]: 'Vehicle Make',
  [DocusignFieldTabLabel.vehicleModel3]: 'Vehicle Model',
  [DocusignFieldTabLabel.vehicleVIN3]: 'Vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate3]: 'Vehicle License Plate',
  [DocusignFieldTabLabel.gvw3]: 'Gross Vehicle Weight (GVW)',
  [DocusignFieldTabLabel.vehicleType3]: 'Vehicle Type',
  [DocusignFieldTabLabel.vehicleTypeOther3]: 'Other Vehicle Type',
  [DocusignFieldTabLabel.taxClassificationType]:
    'Tax Classification (This info will be used for the W9 form)',
  [DocusignFieldTabLabel.llcType]: 'LLC (If selected, you must select one of the following)',
  [DocusignFieldTabLabel.exemptPayeeCode]:
    'Exempt payee code, if any (This info will be used for the W9 form and is optional, can leave blank)',
  [DocusignFieldTabLabel.exemptionFatcaCode]:
    'Exemption from Foreign Account Tax Compliance Act (FATCA) reporting code, if any (This info will be used for the W9 form and is optional, can leave blank)',
  [DocusignFieldTabLabel.mmsOregonAddress]: '',
  [DocusignFieldTabLabel.driverLicenseNumber]: "Driver's License Number",
  [DocusignFieldTabLabel.driverLicenseState]: "Driver's License State",
  [DocusignFieldTabLabel.otherForeignPartners]:
    'If you selected “Partnership” or “Trust/estate,” or checked “LLC” and entered “P” as its tax classification above, AND you are providing this form to a partnership, trust, or estate in which you have an ownership interest, check this box if you have any foreign partners, owners, or beneficiaries. (otherwise leave unchecked)',
  [DocusignFieldTabLabel.otherTaxClassification]: 'Other Tax Classification',
  [DocusignFieldTabLabel.inselAgreementCheckbox]: 'Insel Agreement Checkbox',
  [DocusignFieldTabLabel.taxId]: 'Tax ID',
  [DocusignFieldTabLabel.companyTitle]: 'Company Title',
  [DocusignFieldTabLabel.smartDeliveryCheckboxLease]:
    'Bi-Weekly Lease Fee for Application License(s): 40$',
  [DocusignFieldTabLabel.smartDeliveryCheckboxAdAck]:
    'By completing this checkbox, I agree to participate in this optional advertising program.',
  [DocusignFieldTabLabel.smartDeliveryCheckboxShirt]:
    'Advertising Short Sleeve Shirt S, M, L, XL, 2XL, 3XL (One Time): 30$',
  [DocusignFieldTabLabel.smartDeliveryCheckboxIdBadge]:
    'Advertising ID Badge Fee (Recurring Annually): 20$',
  [DocusignFieldTabLabel.smartDeliveryCheckboxDecal]: 'Advertising Decal Fee (Set) (One Time): 50$',
  [DocusignFieldTabLabel.addressSinceDate]: 'Current Address Since',
  [DocusignFieldTabLabel.prevAddressSinceDate1]: 'Previous Address From',
  [DocusignFieldTabLabel.prevAddressSinceDate2]: 'Previous Address From',
  [DocusignFieldTabLabel.w9FullName]:
    "1. Name of entity/individual. An entry is required. (For a sole proprietor or disregarded entity, enter the owner's name on line 1, and enter the business/disregarded entity's name on line 2.)",
  [DocusignFieldTabLabel.w9BusinessName]:
    '2. Business name/disregarded entity name, if different from above.',
  [DocusignFieldTabLabel.w9Address]: 'Address',
  [DocusignFieldTabLabel.w9City]: 'City',
  [DocusignFieldTabLabel.w9State]: 'State',
  [DocusignFieldTabLabel.w9County]: 'County',
  [DocusignFieldTabLabel.w9Zipcode]: 'ZIP code',
  [DocusignFieldTabLabel.w9Ssn]: 'Social security number',
  [DocusignFieldTabLabel.w9Ein]: 'Employer identification number',
  [DocusignFieldTabLabel.bankName]: 'Bank Name',
  [DocusignFieldTabLabel.bankRoutingNumber]: 'Routing Number',
  [DocusignFieldTabLabel.bankAccountNumber]: 'Account Number',
  [DocusignFieldTabLabel.bankAccountType]: 'Account Type',
}

export enum DocusignSectionTitle {
  personalInformation = 'personalInformation',
  identificationLegalDocuments = 'identificationLegalDocuments',
  addressLocationInformation = 'addressLocationInformation',
  bankAccountInformation = 'bankAccountInformation',
  prevAddressInformation1 = 'prevAddressInformation1',
  prevAddressInformation2 = 'prevAddressInformation2',
  businessTaxInformation = 'businessTaxInformation',
  insuranceBeneficiaryDetails = 'insuranceBeneficiaryDetails',
  primaryVehicleInformation = 'primaryVehicleInformation',
  additionalVehicleInformation1 = 'additionalVehicleInformation1',
  additionalVehicleInformation2 = 'additionalVehicleInformation2',
  additionalInformation = 'additionalInformation',
  smartDeliverySection1 = 'smartDeliverySection1',
  smartDeliverySection2 = 'smartDeliverySection2',
}

export const docusignSectionsTitleMap = {
  [DocusignSectionTitle.personalInformation]: 'Personal Information',
  [DocusignSectionTitle.identificationLegalDocuments]: 'Identification & Legal Documents',
  [DocusignSectionTitle.addressLocationInformation]: 'Address & Location Information',
  [DocusignSectionTitle.bankAccountInformation]: 'Bank Account Information',
  [DocusignSectionTitle.prevAddressInformation1]:
    'Additional Previous Address Within the Last 7 Years',
  [DocusignSectionTitle.prevAddressInformation2]:
    'Additional Previous Address Within the Last 7 Years',
  [DocusignSectionTitle.businessTaxInformation]: 'Business & Tax Information',
  [DocusignSectionTitle.insuranceBeneficiaryDetails]:
    'Insurance & Beneficiary Details (This info will be used for your Occupational Accident Insurance)',
  [DocusignSectionTitle.primaryVehicleInformation]: 'Primary Vehicle Information',
  [DocusignSectionTitle.additionalVehicleInformation1]: 'Additional Vehicle Information',
  [DocusignSectionTitle.additionalVehicleInformation2]: 'Additional Vehicle Information',
  [DocusignSectionTitle.additionalInformation]: 'Additional Information',
  [DocusignSectionTitle.smartDeliverySection1]: 'Contractor acknowledges receipt of the following:',
  [DocusignSectionTitle.smartDeliverySection2]:
    'Advertising agreement. Contractor rents and acknowledges receipt of the following items from Carrier and agrees to an initial rental fee payment for the duration of the contract, on the terms set forth below:',
}

export const docusignSectionsMap: Record<DocusignSectionTitle, DocusignFieldTabLabel[]> = {
  [DocusignSectionTitle.personalInformation]: [
    DocusignFieldTabLabel.fullName,
    DocusignFieldTabLabel.firstName,
    DocusignFieldTabLabel.lastName,
    DocusignFieldTabLabel.mi,
    DocusignFieldTabLabel.email,
    DocusignFieldTabLabel.dob,
    DocusignFieldTabLabel.phoneNumber,
    DocusignFieldTabLabel.phoneNumberHome,
    DocusignFieldTabLabel.driverNumber,
    DocusignFieldTabLabel.businessName,
  ],
  [DocusignSectionTitle.identificationLegalDocuments]: [
    DocusignFieldTabLabel.driverLicenseNumber,
    DocusignFieldTabLabel.driverLicenseState,
    DocusignFieldTabLabel.ssn,
    DocusignFieldTabLabel.ssnLast4,
    DocusignFieldTabLabel.tin,
    DocusignFieldTabLabel.fein,
    DocusignFieldTabLabel.ein,
    DocusignFieldTabLabel.taxId,
  ],
  [DocusignSectionTitle.addressLocationInformation]: [
    DocusignFieldTabLabel.address,
    DocusignFieldTabLabel.city,
    DocusignFieldTabLabel.state,
    DocusignFieldTabLabel.county,
    DocusignFieldTabLabel.zipcode,
    DocusignFieldTabLabel.cityStateZipcode,
    DocusignFieldTabLabel.addressSinceDate,
  ],
  [DocusignSectionTitle.bankAccountInformation]: [
    DocusignFieldTabLabel.bankName,
    DocusignFieldTabLabel.bankRoutingNumber,
    DocusignFieldTabLabel.bankAccountNumber,
    DocusignFieldTabLabel.bankAccountType,
  ],
  [DocusignSectionTitle.prevAddressInformation1]: [
    DocusignFieldTabLabel.prevAddress1,
    DocusignFieldTabLabel.prevCity1,
    DocusignFieldTabLabel.prevState1,
    DocusignFieldTabLabel.prevZipcode1,
    DocusignFieldTabLabel.prevAddressSinceDate1,
  ],
  [DocusignSectionTitle.prevAddressInformation2]: [
    DocusignFieldTabLabel.prevAddress2,
    DocusignFieldTabLabel.prevCity2,
    DocusignFieldTabLabel.prevState2,
    DocusignFieldTabLabel.prevZipcode2,
    DocusignFieldTabLabel.prevAddressSinceDate2,
  ],
  [DocusignSectionTitle.businessTaxInformation]: [
    DocusignFieldTabLabel.w9FullName,
    DocusignFieldTabLabel.w9BusinessName,
    DocusignFieldTabLabel.companyTitle,
    DocusignFieldTabLabel.taxClassificationType,
    DocusignFieldTabLabel.otherTaxClassification,
    DocusignFieldTabLabel.llcType,
    DocusignFieldTabLabel.otherForeignPartners,
    DocusignFieldTabLabel.exemptPayeeCode,
    DocusignFieldTabLabel.exemptionFatcaCode,
    DocusignFieldTabLabel.w9Address,
    DocusignFieldTabLabel.w9City,
    DocusignFieldTabLabel.w9State,
    DocusignFieldTabLabel.w9County,
    DocusignFieldTabLabel.w9Zipcode,
    DocusignFieldTabLabel.w9Ssn,
    DocusignFieldTabLabel.w9Ein,
  ],
  [DocusignSectionTitle.insuranceBeneficiaryDetails]: [
    DocusignFieldTabLabel.beneficiary,
    DocusignFieldTabLabel.beneficiaryFirstName,
    DocusignFieldTabLabel.beneficiaryLastName,
    DocusignFieldTabLabel.beneficiaryMI,
    DocusignFieldTabLabel.beneficiaryAddress,
    DocusignFieldTabLabel.beneficiaryRelationship,
    DocusignFieldTabLabel.beneficiaryDeathToEstateCheckbox,
    DocusignFieldTabLabel.otherInsurancePlan,
    DocusignFieldTabLabel.insuranceCarrier,
  ],
  [DocusignSectionTitle.primaryVehicleInformation]: [
    DocusignFieldTabLabel.vehicleYear,
    DocusignFieldTabLabel.vehicleMake,
    DocusignFieldTabLabel.vehicleModel,
    DocusignFieldTabLabel.vehicleVIN,
    DocusignFieldTabLabel.vehicleLicensePlate,
    DocusignFieldTabLabel.gvw,
    DocusignFieldTabLabel.vehicleType,
    DocusignFieldTabLabel.vehicleTypeOther,
    DocusignFieldTabLabel.vehicleTypeRequired,
    DocusignFieldTabLabel.vehicleTypeOtherRequired,
  ],
  [DocusignSectionTitle.additionalVehicleInformation1]: [
    DocusignFieldTabLabel.vehicleYear2,
    DocusignFieldTabLabel.vehicleMake2,
    DocusignFieldTabLabel.vehicleModel2,
    DocusignFieldTabLabel.vehicleVIN2,
    DocusignFieldTabLabel.vehicleLicensePlate2,
    DocusignFieldTabLabel.gvw2,
    DocusignFieldTabLabel.vehicleType2,
    DocusignFieldTabLabel.vehicleTypeOther2,
  ],
  [DocusignSectionTitle.additionalVehicleInformation2]: [
    DocusignFieldTabLabel.vehicleYear3,
    DocusignFieldTabLabel.vehicleMake3,
    DocusignFieldTabLabel.vehicleModel3,
    DocusignFieldTabLabel.vehicleVIN3,
    DocusignFieldTabLabel.vehicleLicensePlate3,
    DocusignFieldTabLabel.gvw3,
    DocusignFieldTabLabel.vehicleType3,
    DocusignFieldTabLabel.vehicleTypeOther3,
  ],
  [DocusignSectionTitle.additionalInformation]: [
    DocusignFieldTabLabel.eSignatureAck,
    DocusignFieldTabLabel.inselAgreementCheckbox,
  ],
  [DocusignSectionTitle.smartDeliverySection1]: [DocusignFieldTabLabel.smartDeliveryCheckboxLease],
  [DocusignSectionTitle.smartDeliverySection2]: [
    DocusignFieldTabLabel.smartDeliveryCheckboxAdAck,
    DocusignFieldTabLabel.smartDeliveryCheckboxShirt,
    DocusignFieldTabLabel.smartDeliveryCheckboxIdBadge,
    DocusignFieldTabLabel.smartDeliveryCheckboxDecal,
  ],
}

export const DocusignFieldPlaceholders = {
  [DocusignFieldTabLabel.phoneNumber]: 'Enter phone number',
  [DocusignFieldTabLabel.phoneNumberHome]: 'Enter home phone number',
  [DocusignFieldTabLabel.email]: 'Enter email address',
  [DocusignFieldTabLabel.fullName]: 'Enter full name',
  [DocusignFieldTabLabel.firstName]: 'Enter first name',
  [DocusignFieldTabLabel.lastName]: 'Enter last name',
  [DocusignFieldTabLabel.mi]: 'Enter middle initial',
  [DocusignFieldTabLabel.driverNumber]: 'Enter driver number',
  [DocusignFieldTabLabel.address]: 'Enter address (number, street, and apt. or suite no.)',
  [DocusignFieldTabLabel.city]: 'Enter city',
  [DocusignFieldTabLabel.state]: 'Enter state',
  [DocusignFieldTabLabel.zipcode]: 'Enter ZIP code',
  [DocusignFieldTabLabel.county]: 'Enter county',
  [DocusignFieldTabLabel.cityStateZipcode]: 'Enter city, state, and ZIP code',
  [DocusignFieldTabLabel.prevAddress1]: 'Enter address (number, street, and apt. or suite no.)',
  [DocusignFieldTabLabel.prevCity1]: 'Enter city',
  [DocusignFieldTabLabel.prevState1]: 'Enter state',
  [DocusignFieldTabLabel.prevZipcode1]: 'Enter ZIP code',
  [DocusignFieldTabLabel.prevAddress2]: 'Enter address (number, street, and apt. or suite no.)',
  [DocusignFieldTabLabel.prevCity2]: 'Enter city',
  [DocusignFieldTabLabel.prevState2]: 'Enter state',
  [DocusignFieldTabLabel.prevZipcode2]: 'Enter ZIP code',
  [DocusignFieldTabLabel.ssn]: 'Enter social security number',
  [DocusignFieldTabLabel.ssnLast4]: 'Enter last 4 digits of social security number',
  [DocusignFieldTabLabel.tin]: 'Enter taxpayer ID number',
  [DocusignFieldTabLabel.fein]: 'Enter federal employer ID number',
  [DocusignFieldTabLabel.dob]: 'Enter your date of birth',
  [DocusignFieldTabLabel.beneficiary]: 'Enter beneficiary',
  [DocusignFieldTabLabel.beneficiaryRelationship]: 'Enter relationship to beneficiary',
  [DocusignFieldTabLabel.beneficiaryFirstName]: 'Enter beneficiary first name',
  [DocusignFieldTabLabel.beneficiaryLastName]: 'Enter beneficiary last name',
  [DocusignFieldTabLabel.beneficiaryMI]: 'Enter beneficiary middle initial',
  [DocusignFieldTabLabel.beneficiaryAddress]: 'Enter beneficiary address',
  [DocusignFieldTabLabel.beneficiaryDeathToEstateCheckbox]: '',
  [DocusignFieldTabLabel.insuranceCarrier]: 'Enter insurance carrier',
  [DocusignFieldTabLabel.otherInsurancePlan]: '',
  [DocusignFieldTabLabel.eSignatureAck]: '',
  [DocusignFieldTabLabel.businessName]: 'Enter business entity name',
  [DocusignFieldTabLabel.ein]: 'Enter employer identification number',
  [DocusignFieldTabLabel.vehicleYear]: 'Enter vehicle year',
  [DocusignFieldTabLabel.vehicleMake]: 'Enter vehicle make',
  [DocusignFieldTabLabel.vehicleModel]: 'Enter vehicle model',
  [DocusignFieldTabLabel.vehicleVIN]: 'Enter vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate]: 'Enter vehicle license plate',
  [DocusignFieldTabLabel.gvw]: 'Enter gross vehicle weight (GVW)',
  [DocusignFieldTabLabel.vehicleType]: 'Select vehicle type',
  [DocusignFieldTabLabel.vehicleTypeOther]: 'Specify other vehicle type',
  [DocusignFieldTabLabel.vehicleTypeRequired]: 'Select vehicle type',
  [DocusignFieldTabLabel.vehicleTypeOtherRequired]: 'Specify other vehicle type',
  [DocusignFieldTabLabel.vehicleYear2]: 'Enter additional vehicle year',
  [DocusignFieldTabLabel.vehicleMake2]: 'Enter additional vehicle make',
  [DocusignFieldTabLabel.vehicleModel2]: 'Enter additional vehicle model',
  [DocusignFieldTabLabel.vehicleVIN2]: 'Enter additional vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate2]: 'Enter additional vehicle license plate',
  [DocusignFieldTabLabel.gvw2]: 'Enter gross vehicle weight (GVW)',
  [DocusignFieldTabLabel.vehicleType2]: 'Select vehicle type',
  [DocusignFieldTabLabel.vehicleTypeOther2]: 'Specify other vehicle type',
  [DocusignFieldTabLabel.vehicleYear3]: 'Enter additional vehicle year',
  [DocusignFieldTabLabel.vehicleMake3]: 'Enter additional vehicle make',
  [DocusignFieldTabLabel.vehicleModel3]: 'Enter additional vehicle model',
  [DocusignFieldTabLabel.vehicleVIN3]: 'Enter additional vehicle VIN',
  [DocusignFieldTabLabel.vehicleLicensePlate3]: 'Enter additional vehicle license plate',
  [DocusignFieldTabLabel.gvw3]: 'Enter gross vehicle weight (GVW)',
  [DocusignFieldTabLabel.vehicleType3]: 'Select vehicle type',
  [DocusignFieldTabLabel.vehicleTypeOther3]: 'Specify other vehicle type',
  [DocusignFieldTabLabel.taxClassificationType]: '',
  [DocusignFieldTabLabel.llcType]: 'Select LLC type',
  [DocusignFieldTabLabel.exemptPayeeCode]: 'Exempt payee code (if any)',
  [DocusignFieldTabLabel.exemptionFatcaCode]:
    'Exemption from Foreign Account Tax Compliance Act (FATCA) reporting code (if any)',
  [DocusignFieldTabLabel.mmsOregonAddress]: '',
  [DocusignFieldTabLabel.driverLicenseNumber]: 'Enter driver license number',
  [DocusignFieldTabLabel.driverLicenseState]: 'Enter driver license state',
  [DocusignFieldTabLabel.otherForeignPartners]: '',
  [DocusignFieldTabLabel.otherTaxClassification]: 'Enter other tax classification',
  [DocusignFieldTabLabel.inselAgreementCheckbox]: '',
  [DocusignFieldTabLabel.taxId]: 'Enter tax ID',
  [DocusignFieldTabLabel.companyTitle]: 'Enter company title',
  [DocusignFieldTabLabel.smartDeliveryCheckboxLease]: '',
  [DocusignFieldTabLabel.smartDeliveryCheckboxAdAck]: '',
  [DocusignFieldTabLabel.smartDeliveryCheckboxShirt]: '',
  [DocusignFieldTabLabel.smartDeliveryCheckboxIdBadge]: '',
  [DocusignFieldTabLabel.smartDeliveryCheckboxDecal]: '',
  [DocusignFieldTabLabel.addressSinceDate]: 'Enter date (MM/YYYY)',
  [DocusignFieldTabLabel.prevAddressSinceDate1]: 'Enter date (MM/YYYY)',
  [DocusignFieldTabLabel.prevAddressSinceDate2]: 'Enter date (MM/YYYY)',
  [DocusignFieldTabLabel.w9FullName]: 'Enter full name',
  [DocusignFieldTabLabel.w9BusinessName]: 'Enter business name',
  [DocusignFieldTabLabel.w9Address]: 'Enter address',
  [DocusignFieldTabLabel.w9City]: 'Enter city',
  [DocusignFieldTabLabel.w9State]: 'Enter state',
  [DocusignFieldTabLabel.w9County]: 'Enter county',
  [DocusignFieldTabLabel.w9Zipcode]: 'Enter ZIP code',
  [DocusignFieldTabLabel.w9Ssn]: 'Enter social security number',
  [DocusignFieldTabLabel.w9Ein]: 'Enter employer identification number',
  [DocusignFieldTabLabel.bankName]: 'Enter bank name',
  [DocusignFieldTabLabel.bankRoutingNumber]: 'Enter bank routing number',
  [DocusignFieldTabLabel.bankAccountNumber]: 'Enter bank account number',
  [DocusignFieldTabLabel.bankAccountType]: 'Select bank account type',
}

export const llcTypeOptions = [
  { value: 'C', label: 'C corporation' },
  { value: 'S', label: 'S corporation' },
  { value: 'P', label: 'Partnership' },
]

export enum TaxClassificationType {
  Individual = 'individual',
  CCorp = 'cCorp',
  SCorp = 'sCorp',
  Partnership = 'partnership',
  Trust = 'trust',
  Llc = 'llc',
  Other = 'other',
}

export enum DocusignVehicleType {
  Automobile = 'automobile',
  Pickup = 'pickup',
  Van = 'van',
  SportUtility = 'sportUtility',
  MediumWeight = 'mediumWeight',
  Other = 'other',
}

export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

export const DocusignFieldSelectOptions: any = {
  [DocusignFieldTabLabel.state]: states,
  [DocusignFieldTabLabel.driverLicenseState]: states,
  [DocusignFieldTabLabel.w9State]: states,
  [DocusignFieldTabLabel.llcType]: llcTypeOptions,
}

export const DocusignTaxClassificationLabelMap: { [key in TaxClassificationType]: string } = {
  [TaxClassificationType.Individual]: 'Individual/sole proprietor',
  [TaxClassificationType.CCorp]: 'C corporation',
  [TaxClassificationType.SCorp]: 'S corporation',
  [TaxClassificationType.Partnership]: 'Partnership',
  [TaxClassificationType.Trust]: 'Trust/estate',
  [TaxClassificationType.Llc]: 'LLC',
  [TaxClassificationType.Other]: 'Other',
}

export const DocusignVehicleTypeLabelMap: { [key in DocusignVehicleType]: string } = {
  [DocusignVehicleType.Automobile]: 'Automobile',
  [DocusignVehicleType.Pickup]: 'Pickup Truck',
  [DocusignVehicleType.Van]: 'Van',
  [DocusignVehicleType.SportUtility]: 'Sport Utility',
  [DocusignVehicleType.MediumWeight]: 'Medium Weight (10,001-26,000 pounds)',
  [DocusignVehicleType.Other]: 'Other (Specify)',
}

export const DocusignBankAccountLabelMap: { [key in BankAccountType]: string } = {
  [BankAccountType.Checking]: 'Checking ',
  [BankAccountType.Savings]: 'Savings',
}

export const DocusignDisabledFields: DocusignFieldTabLabel[] = [
  DocusignFieldTabLabel.smartDeliveryCheckboxShirt,
  DocusignFieldTabLabel.smartDeliveryCheckboxIdBadge,
  DocusignFieldTabLabel.smartDeliveryCheckboxDecal,
]
